export const textClamp = (text = "", maxChars = 100) =>
  text.length > maxChars ? `${text.slice(0, maxChars).trim()}...` : text

export const sanitizeHtml = (html) => html?.replace(/<.*?>/g, "")
